
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/main",
      function () {
        return require("private-next-pages/main.tsx");
      }
    ]);
  